module.exports = __webpack_public_path__ + "site/img/v2-bg4.bd958d0c.png";